import React from 'react'

export interface IconLinkedInTN {
    className?: string
}

export const IconLinkedInTN: React.FC<IconLinkedInTN> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 19"
        fill="none"
        className={className}
    >
        <g clipPath="url(#clip0_7231_8469)">
            <path
                d="M3.735 2.729C3.735 3.76475 2.9025 4.604 1.875 4.604C0.8475 4.604 0.015 3.76475 0.015 2.729C0.015 1.694 0.8475 0.854004 1.875 0.854004C2.9025 0.854004 3.735 1.694 3.735 2.729ZM3.75 6.104H0V18.104H3.75V6.104ZM9.7365 6.104H6.0105V18.104H9.73725V11.8048C9.73725 8.30225 14.259 8.01575 14.259 11.8048V18.104H18V10.5058C18 4.59575 11.3085 4.811 9.7365 7.72025V6.104Z"
                fill="#161616"
            />
        </g>
        <defs>
            <clipPath id="clip0_7231_8469">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.104004)"
                />
            </clipPath>
        </defs>
    </svg>
)
IconLinkedInTN.displayName = 'IconLinkedInTN'
